"use client"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"

export const useTabSearchParams = (
  defaultTab: string,
  key: string = "tab",
): [string, (tab: string) => void] => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const [tab, setActiveTab] = useState(searchParams.get(key) ?? defaultTab)
  const searchParamTab = searchParams.get(key)
  useEffect(() => {
    if (!searchParamTab || searchParamTab === tab) {
      return
    }
    setActiveTab(searchParamTab)
  }, [searchParamTab])
  const setTab = (value: string) => {
    setActiveTab(value)
    const current = new URLSearchParams(Array.from(searchParams.entries()))
    current.set(key, value)
    const search = current.toString()
    const query = search ? `?${search}` : ""
    router.push(`${pathname}${query}`)
  }
  return [tab, setTab]
}
